import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';

const imageSize = 30;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${dimensions.coreSpacing}px;
  // height: 500px;

  .calls {
    text-align: center;
    margin: auto;
  }

  .customTabs .nav-tabs {
    margin-bottom: 1.5rem;
    border: none;
  }
  .customTabs .nav-tabs > li > a {
    font-weight: 600;
    color: #373737;
    // border-bottom: 2px solid #DDD;
    margin: 0px;
    border-left: none;
    padding: 10px 50px;
    border-top: none;
    border-right: none;
  }
  .customTabs .nav-tabs > li.active > a {
    border-bottom: 2px solid #4d528e;
    border-left: none;
    border-top: none;
    border-right: none;
    border-bottom-color: #4d528e;
    color: #4d528e;
    background: none;
  }
  .customTabs .nav-tabs > li > a:focus {
    outline: none;
  }
  .fileI {
    height: 211px;
    width: 100%;
    margin: 15px 0 auto;
    position: relative;
    text-align: center;
    line-height: 195px;
    border: 1px dashed #dae0e6;
    display: inline-block;
    transition: transform 0.3s;
    background: #faf8ff;
    letter-spacing: 0.23px;
    color: #5b5b5b;
  }
  .fileI img {
    display: block;
    margin-left: 150px;
    margin-top: 53px;
    margin-bottom: -70px;
  }
  input[type='file'] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  .FModal {
    background: #000;
  }
`;

export { MemberImg, Members, More, DataWrapperClass, Row };



// WEBPACK FOOTER //
// src/modules/screens/settings/CSAT/styles.js